var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Paper, useTheme } from "@mui/material";
import Stack from "@mui/material/Stack";
import { useEffect } from "react";
import { useLoaderData, useLocation } from "react-router-dom";
import { BrandLogoLink } from "./Shared/components/Navigation/BrandLogoLink";
import { LogLevel } from "./Shared/hooks/useLogging/Logging-types";
import { useLogging } from "./Shared/hooks/useLogging/useLogging";
import { axiosPrivate } from "./api/axios";
import { MuiMarkdown_V2 } from "./Shared/components/MuiMarkdown/MuiMarkdown_V2";
export const PageNotFound = () => {
    const configurableText = useLoaderData();
    const theme = useTheme();
    const location = useLocation();
    const { datadogLog } = useLogging();
    useEffect(() => {
        var _a, _b;
        // We store the previous route in location state if possible. If we don't have a previous route then window.location.pathname is the route we should log.
        // location.pathName is the current route (/404) so we don't want to log that
        const nonExistentRoute = (_b = (_a = location.state) === null || _a === void 0 ? void 0 : _a.prevRoute) !== null && _b !== void 0 ? _b : window.location.pathname;
        datadogLog(`Route not found: ${nonExistentRoute}`, LogLevel.INFO);
    }, []);
    const logoStyles = {
        padding: theme.spacing(1),
        borderRadius: theme.shape.borderRadius,
        marginBottom: theme.spacing(5),
        display: "flex",
        "& img": {
            maxWidth: theme.spacing(31.25),
            maxHeight: theme.spacing(11.25),
        },
    };
    return (_jsx(Paper, Object.assign({ style: { padding: theme.spacing(3), margin: theme.spacing(4, 0) } }, { children: _jsxs(Stack, Object.assign({ justifyContent: "center", alignItems: "center", style: { width: "100%", margin: theme.spacing(4, 0) }, spacing: 1 }, { children: [_jsx(BrandLogoLink, Object.assign({}, { logoStyles })), _jsx(Box, { children: _jsx(MuiMarkdown_V2, { children: configurableText }) })] })) })));
};
export const PageNotFoundLoader = () => __awaiter(void 0, void 0, void 0, function* () {
    return axiosPrivate
        .get("/React/GetPageNotFoundMarkdown")
        .then((res) => {
        var _a;
        return (_a = res.data.configurableText) !== null && _a !== void 0 ? _a : "";
    })
        .catch((e) => {
        return e;
    });
});
